import {
  BuildCartonRequest,
  BuildPalletOpRequest,
  MovePalletResponse,
  RpaasRtvWmsBuildCartonObject,
  RpaasRtvWmsBuildPalletObject,
  ScanLocatinResponse,
  ScanPalletResponse,
} from 'types';
import { getRequestWithPRBE, postRequest, putRequestWithPRBE } from '.';

export const buildCarton = async (
  payload: BuildCartonRequest
): Promise<RpaasRtvWmsBuildCartonObject | undefined> =>
  postRequest<RpaasRtvWmsBuildCartonObject>('rpaas-rtv-wms-build-carton', payload);

export const buildPallet = async (
  payload: BuildPalletOpRequest
): Promise<RpaasRtvWmsBuildPalletObject | undefined> =>
  postRequest<RpaasRtvWmsBuildPalletObject>('rpaas-rtv-wms-build-pallet', payload);

export const scanPallet = async (palletId: string): Promise<ScanPalletResponse> =>
  getRequestWithPRBE(`rtv/wms/pallet/${palletId}`);

export const scanLocation = async (locationId: string): Promise<ScanLocatinResponse> =>
  getRequestWithPRBE(`rtv/wms/locations/${locationId}`);

export const movePallet = async (
  palletId: string,
  locationId: string
): Promise<MovePalletResponse> =>
  putRequestWithPRBE(`rtv/wms/pallet-destination/${palletId}/update/${locationId}`);
